export default {

    BillRows: 'Invoice Row|Invoice Rows',
};
